import React, { useState, useEffect } from 'react'
import { useTranslate, usePermissions } from 'react-admin'
import { Box, IconButton, Typography, useTheme, Button, Paper, List, ListItem, makeStyles, MenuItem, CircularProgress } from '@material-ui/core'
import icBlueAdd from '../assets/icons/icBlueAdd.png'
import icWhiteAdd from '../assets/icons/white-add.png'
import colors from '../CustomizedUIs/Colors'
import ic_attachment from '../assets/icons/ic_attachment.png'
import ic_attach_selected from '../assets/icons/ic_attach_selected.png'
import ic_computer from '../assets/icons/computer.png'
import ic_folder from '../assets/icons/folder-empty.png'
import icDelete from '../assets/icons/Trash-black.png'
import icClock from '../assets/icons/time.png'
import icCopy from '../assets/icons/copy.png'
import icPlayChannel from '../assets/icons/play-info-channel.png'
import icOverlay from '../assets/icons/overlay.png'
import icRotate from '../assets/icons/rotate.png'
import icRefresh from '../assets/icons/favicon.png'
import DialogChooseFile from '../file-management/file-management-dialog'
import CustomPopover from '../CustomizedUIs/CustomPopoverArrow'
import {
    usePopupState,
    bindToggle
} from 'material-ui-popup-state/hooks'
import GreenSwitch from '../CustomizedUIs/GreenSwitch'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import icChevronLeft from '../assets/icons/icChevronLeft.png'
import icChevronRight from '../assets/icons/icChevronRight.png'
import DialogEdit from './Dialog-EditSchedule.jsx'
import OverlayEditor from './OverlayEditor';
import { baseAuthUrl } from '../authProvider';
import Select from '@material-ui/core/Select';
import { isVideo, isImage, generateRandomString, calcuMediaHeight, calcuMediaWidth, getDimensions, resolutions, loadVideo } from "../utils";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import OverlayItem from './OverlayItem'
import { useDispatch } from 'react-redux';
import { isBlockingInfoChannel } from '../infochannels/action';
import { useSelector } from 'react-redux';
import Image from 'material-ui-image';

var month = new Array();
month[0] = "January";
month[1] = "February";
month[2] = "March";
month[3] = "April";
month[4] = "May";
month[5] = "June";
month[6] = "July";
month[7] = "August";
month[8] = "September";
month[9] = "October";
month[10] = "November";
month[11] = "December";

const useStyles = makeStyles(theme => ({
    ContentPresenter: {
        overflow: 'hidden',
        position: "relative",
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    typography: {
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.25',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer',
        opacity: 0,
    },
    select: {
        width: 75,
        marginLeft: 8,
        backgroundColor: '#f3f7fa',
        borderRadius: 4,

    },
    menuItem: {
        marginLeft: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.25',
        letterSpacing: '0.13px',
        color: 'var(--slate-grey)'
    },
    scrollList: {
        display: 'flex',
        // overflowX: 'auto',

        // '&::-webkit-scrollbar': {
        //     display: 'none'
        // },
        // scrollbarWidth: 0,
    },
    titleDetailSchedule: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#2b3648',
        marginLeft: '8px'
    },
    titleSchedule: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#212936'
    },
    titleChooseItem: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064'
    }
}));


function scrollLeft(element, change, duration) {
    var start = element.scrollLeft,
        currentTime = 0,
        increment = 10;


    var animateScroll = function () {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollLeft = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};



const MediaItem = ({ itemData, fi, ...props }) => {
    const theme = useTheme()
    const classes = useStyles()
    const translate = useTranslate()
    const popupState = usePopupState({ variant: 'popper', popupId: 'EditImage' });
    const [ist, setIst] = useState(itemData.imageShowTime)
    const [openOverlayEditor, setOpenOverlayEditor] = useState(false);
    const [stateImage, setStateImage] = useState({
        count: 0,
        show: true
    });
    const filePath = !itemData.owner && !itemData.file ? itemData.fd : baseAuthUrl + "/media/" + itemData.fd;
    const dispatch = useDispatch();
    const screenSize = {
        width: props.pivot ? 50 : 160,
        height: props.pivot ? 95 : 95
    }
    const handleChange = (event) => {
        dispatch(isBlockingInfoChannel(true))
        setIst(event.target.value)
        let temps = [...props.data];
        temps[props.index].fileOfSchedule[fi].imageShowTime = event.target.value
        props.setData(temps)
    }

    const handleCopyFile = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data];
        let temp = { ...itemData }
        temp.id && delete temp.id
        temp.fileId = generateRandomString(10)
        temps[props.index].fileOfSchedule.push(temp)
        props.setData(temps)
        popupState.close()
    }

    const handleDeleteFile = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data];
        let removes = [...props.removes]
        removes.push({ type: 'file', id: itemData.id })
        temps[props.index].fileOfSchedule.splice(fi, 1)
        props.setData(temps)
        props.setRemoves(removes)
        popupState.close()
    }

    const onCloseOverlayEditor = () => {
        setOpenOverlayEditor(false);
        popupState.close();
    }

    const onChangeOverlay = (overlay) => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data];
        temps[props.index].fileOfSchedule[fi].overlay = overlay;
        props.setData(temps);
        setOpenOverlayEditor(false);
        popupState.close()
    }

    const handleRotate = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data];
        temps[props.index].fileOfSchedule[fi].rotate = itemData.rotate === 270 ? 0 : itemData.rotate + 90
        props.setData(temps)
        popupState.close()
    }

    const reload = () => {
        if (!filePath.includes('localhost')) {
            if (!filePath.includes('blob:')) {
                // Check status file valid
                var http = new XMLHttpRequest();

                http.open('GET', filePath, false);
                http.send();

                // console.log('http.status', http.status)
                if (http.status === 404)
                    document.getElementById(`img_${fi}`).setAttribute('src', icRefresh);
                else {
                    if (document.getElementById(`img_${fi}`)) {
                        document.getElementById(`img_${fi}`).style.display = 'block';
                        document.getElementById(`img_${fi}`).setAttribute('src', filePath);
                    }
                }
            }
        }
        else {
            setStateImage({ show: false })
            setTimeout(() => setStateImage(state => ({ count: state.count + 1, show: true })), 2000)
        }
    }

    useEffect(() => {
        setIst(itemData.imageShowTime)
    }, [props.data])

    useEffect(() => {
        // var mediaElem = document.querySelector("video");
        // mediaElem.load();

        var video = document.getElementById(`video_${fi}`);
        if (video) {
            video.src = `${filePath}`;
            video.load();
        }

        // reload()
    }, [fi])

    useEffect(() => {
        var img = document.getElementById(`img_${fi}`)
        if (img) {
            if (img.complete === false) {
                const extension = filePath.split('.')
                if (!isImage(extension[extension.length - 1])) {
                    document.getElementById(`img_${fi}`).setAttribute('src', icRefresh);
                }
                else {
                    // document.getElementById(`img_${fi}`).style.display = 'none';
                    document.getElementById(`img_${fi}`).setAttribute('src', icRefresh);
                    reload()
                }
            }
            else {
                document.getElementById(`img_${fi}`).style.display = 'block';
            }
            // console.log('complete 2', img.complete)
        }
    }, [document.getElementById(`img_${fi}`)?.complete])

    useEffect(() => {
        const extension = filePath.split('.')
        if (!isImage(extension[extension.length - 1])) {
            var img = document.getElementById(`img_${fi}`)
            if (img)
                document.getElementById(`img_${fi}`).setAttribute('src', icRefresh);
        }
    }, [fi])

    const _isVideo = isVideo(itemData.type || itemData.fd.split('.')[itemData.fd.split('.').length - 1]);

    return (
        <Box mx={2} height={123} width={160} borderRadius={4} position='relative'>
            <Box
                className={classes.ContentPresenter}
                width={screenSize.width}
                height={screenSize.height}
            >
                <Box height='100%' display='flex' justifyContent='center' alignItems='center' style={{ backgroundColor: '#000' }}>
                    <Box height='100%' width='100%'>
                        {!_isVideo ? (
                            <img src={stateImage.show ? `${filePath}` : ''}
                                id={`img_${fi}_${itemData.fileId}`}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    transform: `rotate(${itemData.rotate}deg)`,
                                    width: `${props.resolution !== 'No pre-scaling' ? `${screenSize.width + 'px'}` : calcuMediaWidth(itemData.dimension, screenSize, props.pivot, itemData.rotate, props.resolution === 'No pre-scaling')}`,
                                    height: `${props.resolution !== 'No pre-scaling' ? `${screenSize.height + 'px'}` : calcuMediaHeight(itemData.dimension, screenSize, props.pivot, itemData.rotate, props.resolution === 'No pre-scaling')}`,
                                    position: `${props.resolution === 'No pre-scaling' ? 'absolute' : ''}`,
                                    top: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                    bottom: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                    left: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                    right: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                    margin: `${props.resolution === 'No pre-scaling' ? 'auto' : ''}`
                                }}
                                loading="lazy"
                            />
                            // <Image
                            //     src={stateImage.show ? `${filePath}` : ''}
                            //     style={{
                            //         width: `${calcuMediaWidth(itemData.dimension, screenSize, props.pivot, itemData.rotate)}`,
                            //         height: `${calcuMediaHeight(itemData.dimension, screenSize, props.pivot, itemData.rotate)}`,
                            //         transform: `rotate(${itemData.rotate}deg)`,
                            //     }}
                            // />
                        ) : (
                                <video
                                    id={`video_${fi}_${itemData.fileId}`}
                                    src={`${filePath}`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        transform: `rotate(${itemData.rotate}deg)`,
                                        width: `${props.resolution !== 'No pre-scaling' ? `${screenSize.width + 'px'}` : calcuMediaWidth(itemData.dimension, screenSize, props.pivot, itemData.rotate, props.resolution === 'No pre-scaling')}`,
                                        height: `${props.resolution !== 'No pre-scaling' ? `${screenSize.height + 'px'}` : calcuMediaHeight(itemData.dimension, screenSize, props.pivot, itemData.rotate, props.resolution === 'No pre-scaling')}`,
                                        position: `${props.resolution === 'No pre-scaling' ? 'absolute' : ''}`,
                                        top: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                        bottom: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                        left: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                        right: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                                        margin: `${props.resolution === 'No pre-scaling' ? 'auto' : ''}`
                                    }} />
                            )}
                    </Box>
                    <OverlayItem itemData={itemData} resolution={props.resolution} pivot={props.pivot} screenSize={screenSize} index={fi} si={props.index} />
                </Box>
            </Box>
            <IconButton
                {...bindToggle(popupState)}
                style={{
                    position: 'absolute',
                    top: 8, right: 8,
                    backgroundColor: popupState.isOpen ? theme.palette.primary.main : 'white', width: 28, height: 28, padding: 0,
                    border: `solid 2px ${colors.lightBlue['100']}`, borderRadius: 10
                }}>
                <img src={popupState.isOpen ? icWhiteAdd : icBlueAdd} height={16} width={16}></img>
            </IconButton>
            <CustomPopover
                popupState={popupState}
                zIndex={2}
                placement='right-start'
            >
                <Paper style={{ padding: theme.spacing(1), width: 216 }}>
                    <List >
                        <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={handleCopyFile}>
                            <img src={icCopy} width={15} height={15}></img>
                            <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', cursor: 'pointer', marginLeft: theme.spacing(1) }}>{translate(`pos.common.copy`)}</Typography>
                        </ListItem>
                        <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={() => setOpenOverlayEditor(true)}>
                            <img src={icOverlay} width={15} height={15}></img>
                            <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', marginLeft: theme.spacing(1) }}>{translate(`pos.common.overlay`)}</Typography>
                        </ListItem>
                        <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={handleRotate}>
                            <img src={icRotate} width={15} height={15}></img>
                            <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', marginLeft: theme.spacing(1) }}>{translate(`pos.common.rotate`)}</Typography>
                        </ListItem>
                        <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={handleDeleteFile}>
                            <img src={icDelete} width={15} height={15}></img>
                            <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', marginLeft: theme.spacing(1) }}>{translate(`pos.common.delete`)}</Typography>
                        </ListItem>
                        <ListItem style={{ marginTop: theme.spacing(1) }}>
                            <img src={icClock} width={15} height={15}></img>
                            {_isVideo ?
                                <Typography variant='body1'
                                    style={{
                                        marginLeft: 8, padding: '4px 8px', fontSize: 13, fontFamily: 'UniviaPro',
                                        lineHeight: '1.25', letterSpacing: '0.13px', color: 'var(--slate-grey)', backgroundColor: '#F3F7FA'
                                    }}>
                                    {`${ist} sec`}
                                </Typography> :
                                <Select
                                    disabled={_isVideo}
                                    disableUnderline
                                    className={classes.select} labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={ist}
                                    onChange={handleChange}
                                >
                                    {
                                        Array.from({ length: 60 }, (value, index) => (
                                            <MenuItem key={'ist' + index} value={index + 1}> <Typography className={classes.menuItem}>{index + 1 + translate(`pos.infochannel.sec`)}</Typography></MenuItem>
                                        ))
                                    }

                                </Select>
                            }



                        </ListItem>
                        <Box display='flex' justifyContent='flex-end'>
                            <Button size='small' color='primary' onClick={() => popupState.close()}>{translate(`pos.common.close`)}</Button>
                        </Box>
                    </List>
                </Paper>
            </CustomPopover>
            <Box height={28} width={160} bgcolor='#f3f7fa' display='flex' alignItems='center' style={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                <Typography style={{ fontFamily: 'UniviaPro', fontSize: '13px', fontWeight: 'normal', fontStyle: 'normal', fontStretch: 'normal', lineHeight: '24px', letterSpacing: '0.13px', color: '#4f5064' }} >
                    {itemData.name.length > 18 ? itemData.name.substring(0, 17) + '...' : itemData.name}
                </Typography>
            </Box>
            <OverlayEditor
                open={openOverlayEditor}
                handleClose={onCloseOverlayEditor}
                onChangeOverlay={onChangeOverlay}
                itemData={itemData}
                resolution={props.resolution}
                pivot={props.pivot}
            />
        </Box>
    )
}

const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};



const MediaContent = ({ item, ...props }) => {
    const theme = useTheme()
    const classes = useStyles()
    const translate = useTranslate()
    const { permissions, loaded } = usePermissions();
    const [duration, setDuration] = useState(0)
    const popupStateAdd = usePopupState({ variant: 'popper', popupId: 'addImage' });
    const [pickFile, setPickFile] = useState([]);
    const dispatch = useDispatch();
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        setResponse: null
    })


    const scroll = (direction) => {
        scrollLeft(document.getElementById('imgContainer-' + props.index), direction === 'left' ? -600 : 600, 500);
    }

    const handleClearContent = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data]
        let tempsFile = [...temps[props.index].fileOfSchedule]
        temps[props.index].fileOfSchedule = []
        let removes = [...props.removes]
        tempsFile.forEach(item => {
            removes.push({ type: 'file', id: item.id })
        })
        props.setData(temps)
        props.setRemoves(removes)
    }

    const fileBrowserOnChange = async event => {
        popupStateAdd.close()
        var temps = [...props.data]
        dispatch(isBlockingInfoChannel(true))
        var newFiles = [];
        var fileContents = [];
        var files = [...event.target.files]
        files.forEach((e, idx) => {
            temps[props.index].fileOfSchedule = [...temps[props.index].fileOfSchedule, { fileId: generateRandomString(10), loading: true, imageShowTime: 0 }]
            props.setData(temps)
        })
        for (let i = 0; i < files.length; i++) {

            var file = files[i]
            var video = null
            if (file.type.search('video') > -1)
                video = await loadVideo(URL.createObjectURL(file))
            const newFile = {
                fileId: generateRandomString(10),
                imageShowTime: video ? parseInt(video.duration) : props.data[props.index].defaultShowTime,
                rotate: 0,
                name: file.name,
                fd: URL.createObjectURL(file),
                type: file.type.split('/')[1]
            };

            var dimension = { width: '100', height: '100' }
            if (isImage(file.type.split('/')[1]) || isVideo(file.type.split('/')[1]))
                dimension = await getDimensions(newFile.fd, newFile.type);
            newFile.dimension = dimension;
            file.filemapping = newFile.fd;
            newFiles.push(newFile);
            fileContents.push(file)

        }


        let tempsFile = [...props.files]
        tempsFile = tempsFile.concat(fileContents)
        props.setFiles(tempsFile)
        newFiles.forEach((e, index) => {
            temps[props.index].fileOfSchedule[temps[props.index].fileOfSchedule.length - newFiles.length + index] = e
        })
        var temps1 = [...temps]
        props.setData(temps1)
        // event.target.value = null;


    }


    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 3,
            setResponse: setPickFile,
        })
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            setResponse: null
        })
    }

    const onDragEnd = (result) => {
        dispatch(isBlockingInfoChannel(true))
        if (!result.destination) {
            return;
        }

        const newItems = reorder(
            item.fileOfSchedule,
            result.source.index,
            result.destination.index
        );

        props.onDragAndDropFiles(newItems, props.index);
    }

    useEffect(() => {
        var duration = 0
        props.data[props.index].fileOfSchedule.forEach(item => {
            duration += item.imageShowTime
        })
        setDuration(duration)
    }, [props.data, pickFile])

    useEffect(() => {
        const pick = async () => {
            if (pickFile.length > 0) {
                popupStateAdd.close()
                let temps = [...props.data]
                pickFile.forEach((e, idx) => {
                    temps[props.index].fileOfSchedule = [...temps[props.index].fileOfSchedule, { fileId: generateRandomString(10), loading: true, imageShowTime: 0 }]
                    props.setData(temps)
                })
                let temp = []
                for (let i = 0; i < pickFile.length; i++) {
                    var item = pickFile[i]
                    var video = null;
                    if (isVideo(item.type)) {
                        console.log(`${baseAuthUrl}/media/${item.fd}`)
                        video = await loadVideo(`${baseAuthUrl}/media/${item.fd}`)
                    }

                    let obj = {
                        fileId: generateRandomString(10),
                        file: item.id,
                        imageShowTime: video ? parseInt(video.duration) : props.data[props.index].defaultShowTime,
                        rotate: 0,
                        name: item.name,
                        fd: item.fd,
                        type: item.type
                    }
                    var dimension = { width: '100', height: '100' }
                    if (isVideo(item.type) || isImage(item.type))
                        dimension = await getDimensions(`${baseAuthUrl}/media/${item.fd}`, obj.type);
                    obj.dimension = dimension;
                    temp.push(obj)
                }

                //temps[props.index].fileOfSchedule = temps[props.index].fileOfSchedule.concat(temp)
                temp.forEach((e, index) => {
                    temps[props.index].fileOfSchedule[temps[props.index].fileOfSchedule.length - temp.length + index] = e
                })
                var temps1 = [...temps]
                props.setData(temps1)
                setPickFile([])

            }
        }
        pick()

    }, [pickFile])

    if (!loaded) return null
    return (
        <Box>
            <Box width='100%' my={3} height={150} display='flex' justifyContent='space-between' bgcolor='white'>
                <Box onClick={() => { scroll('left') }} bgcolor='#c1e5fa' style={{ cursor: 'pointer', borderTopLeftRadius: 10, borderBottomLeftRadius: 10 }} justifyContent='center' display='flex' alignItems='center' width={30}>
                    <img src={icChevronLeft} width={16} height={16}></img>
                </Box>
                <Box id={'imgContainer-' + props.index} display='flex' style={{ border: '1px solid #c1e5fa' }} py={1} alignItems='center' width='1200px' overflow='hidden' whiteSpace='nowrap'>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable" direction="horizontal">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    className={classes.scrollList}
                                    {...provided.droppableProps}
                                >
                                    {item.fileOfSchedule.map((data, index) => (
                                        <Draggable key={data.fileId} draggableId={data.fileId} index={index} >
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(provided.draggableProps.style)}
                                                >
                                                    {
                                                        data.loading ? <Box height={123} width={193} display='flex' justifyContent='center' alignItems='center' style={{ paddingTop: '2px' }}>
                                                            <CircularProgress color="inherit" />

                                                        </Box>
                                                            :
                                                            <MediaItem key={'media-' + index} itemData={data} fi={index} {...props} resolution={item.resolution} pivot={item.pivot}></MediaItem>
                                                    }

                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </Box>
                <Box
                    onClick={() => { scroll('right') }}
                    bgcolor='#c1e5fa'
                    display='flex'
                    alignItems='center' justifyContent='center'
                    style={{
                        cursor: 'pointer',
                        boxShadow: '-10px 0px 20px 0px rgba(255,255,255,1)',
                        borderTopRightRadius: 10, borderBottomRightRadius: 10
                    }} width={30}>
                    <img src={icChevronRight} width={16} height={16}></img>
                </Box>
            </Box>

            <Box display='flex' alignItems='center'>

                <Button variant='contained' color='primary' style={{ marginRight: theme.spacing(2), fontFamily: 'UniviaPro-Bold', fontSize: 9, lineHeight: '11px', letterSpacing: '0.36px' }}
                    {...bindToggle(popupStateAdd)}>
                    {translate(`pos.infochannel.addMedia`)}
                    <img src={popupStateAdd.isOpen ? ic_attach_selected : ic_attachment} width={15} height={15} style={{ marginLeft: theme.spacing(1) }} />
                </Button>
                <Button variant='contained' color='primary' style={{ marginRight: theme.spacing(2), fontFamily: 'UniviaPro-Bold', fontSize: 9, lineHeight: '11px', letterSpacing: '0.36px', padding: 8 }}
                    onClick={handleClearContent}>
                    {translate(`pos.infochannel.clearContent`)}
                </Button>

                <DialogChooseFile
                    defaultId={openFile.defaultId}
                    open={openFile.status}
                    pickerMode='pickMedia'
                    handleClose={handleClose}
                    setChooseValue={openFile.setResponse}
                    isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                />
                <CustomPopover
                    popupState={popupStateAdd}
                    zIndex={2}
                    placement='bottom-end'

                >
                    <Paper style={{ padding: theme.spacing(1) }}>
                        <List>
                            <ListItem>
                                <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', color: '#000000', fontFamily: 'UniviaPro', marginRight: theme.spacing(1) }}>
                                    {translate(`pos.infochannel.fileFormat`)}
                                </Typography>
                            </ListItem>
                            <ListItem button>
                                <img src={ic_computer} width={19} height={19}></img>
                                <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', cursor: 'pointer', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.computer`)}</Typography>
                                <input type='file' multiple onChange={fileBrowserOnChange} className={classes.input} />
                            </ListItem>
                            <ListItem button onClick={handleOpenFileDialog}>
                                <img src={ic_folder} width={19} height={19}></img>
                                <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.fileManager`)}</Typography>

                            </ListItem>

                            <Box display='flex' justifyContent='flex-end'>
                                <Button size='small' color='primary' onClick={() => popupStateAdd.close()}>{translate(`pos.common.close`)}</Button>
                            </Box>
                        </List>
                    </Paper>
                </CustomPopover>
                <Box display='flex' mr={8}>
                    <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.totalDuration`)}</Typography>
                    <Typography className={classes.titleDetailSchedule} style={{ color: '#4f5064' }}>{new Date(duration * 1000).toISOString().substr(11, 8)}</Typography>
                </Box>
                <Box display='flex'>
                    <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.imageFormat`)}</Typography>
                    <Typography className={classes.titleDetailSchedule} style={{ color: '#4f5064' }}>
                        {
                            item.resolution === '960x540' ? item.pivot ? '540x960, Aspect ratio 9:16' : '960x540, Aspect ratio 16:9'
                                :
                                item.resolution === '1280x720' ? item.pivot ? '720x1280 (HD), Aspect ratio 9:16' : '1280x720 (HD), Aspect ratio 16:9'
                                    :
                                    item.resolution === '1920x1080' ? item.pivot ? '1080x1920 (FULLHD), Aspect ratio 9:16' : '1920x1080 (FULLHD), Aspect ratio 16:9'
                                        :
                                        item.resolution === '3840x2160' ? item.pivot ? '2160x3840 (4K), Aspect ratio 9:16' : '3840x2160 (4K), Aspect ratio 16:9'
                                            :
                                            item.resolution === '7680x4320' ? item.pivot ? '4320x7680 (8K), Aspect ratio 9:16' : '7680x4320 (8K), Aspect ratio 16:9' : 'No pre-scaling'
                        }
                    </Typography>
                </Box>
            </Box>
        </Box>

    )
}


const ChooseSolution = ({ popupState, ...props }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const theme = useTheme()
    const classes = useStyles()
    const translate = useTranslate()
    const [pivot, setPivot] = useState(false)
    const [openPoper, setOpenPopper] = React.useState(false);

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const pickResolution = (value) => {
        let temps = [...props.data]
        temps[props.index].resolution = value
        temps[props.index].pivot = pivot
        props.setData(temps)
        popupState.close()
    }

    return (
        <Box my={3} bgcolor='#f3f7fa' style={{ border: '1px dashed #c1e5fa' }} p={3} display='flex' alignContent='center' justifyContent='center'>
            <Box display='flex' alignItems='center' width='fit-content' style={{ cursor: 'pointer' }} {...bindToggle(popupState)}>
                <img src={ic_attachment} width={27} height={27} style={{ marginRight: theme.spacing(2) }}></img>
                <Typography className={classes.titleChooseItem} >{translate(`pos.infochannel.chooseResolutionAndAddFile`)}</Typography>
            </Box>
            <CustomPopover
                popupState={popupState}
                zIndex={2}
                placement='right-start'
                style={{ marginLeft: theme.spacing(3) }}
            >
                <Paper style={{ padding: theme.spacing(1) }}>
                    <List>
                        <ListItem>
                            <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', fontWeight: 500, fontFamily: 'UniviaPro-Medium', marginRight: theme.spacing(1) }}>
                                {translate(`pos.infochannel.chooseImageResolution`)}
                            </Typography>
                            <CustomPoper

                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.infochannel.imageResolution`)}
                                content={translate(`pos.infochannel.imageResolutionContent`)}
                                icon={<b>?</b>}
                            />
                        </ListItem>
                        <ListItem button onClick={() => pickResolution('960x540')}><Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px' }} >
                            {pivot ? resolutions[0].height + ' x ' + resolutions[0].width + 'px' : resolutions[0].width + ' x ' + resolutions[0].height + 'px'}
                        </Typography></ListItem>
                        <ListItem button onClick={() => pickResolution('1280x720')}><Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px' }} >
                            {pivot ? resolutions[1].height + ' x ' + resolutions[1].width + 'px' : resolutions[1].width + ' x ' + resolutions[1].height + 'px'}
                        </Typography></ListItem>
                        <ListItem button onClick={() => pickResolution('1920x1080')}><Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px' }} >
                            {pivot ? resolutions[2].height + ' x ' + resolutions[2].width + 'px' : resolutions[2].width + ' x ' + resolutions[2].height + 'px'}
                        </Typography></ListItem>
                        <ListItem button onClick={() => pickResolution('3840x2160')}><Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px' }} >
                            {pivot ? resolutions[3].height + ' x ' + resolutions[3].width + 'px' : resolutions[3].width + ' x ' + resolutions[3].height + 'px'}
                        </Typography></ListItem>
                        <ListItem button onClick={() => pickResolution('7680x4320')}><Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px' }}>
                            {pivot ? resolutions[4].height + ' x ' + resolutions[4].width + 'px' : resolutions[4].width + ' x ' + resolutions[4].height + 'px'}
                        </Typography></ListItem>
                        <ListItem button onClick={() => pickResolution('No pre-scaling')}><Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px' }} >{translate(`pos.infochannel.noPreScaling`)}</Typography></ListItem>
                        <ListItem>
                            <Box bgcolor='#f3f7fa' display='flex' width='100%' borderRadius='4px' px={1} py={0.5}>
                                <Box flexGrow={1} display='flex' alignItems='center'>
                                    <Typography style={{ fontSize: 9, fontFamily: 'UniviaPro-Bold', fontWeight: 'bold', letterSpacing: '0.36px', lineHeight: '11px', fontStretch: 'normal', fontStyle: 'normal' }}>{translate(`pos.infochannel.pivotEnable`)}</Typography>
                                </Box>
                                <GreenSwitch size='small' checked={pivot} onChange={() => { setPivot(!pivot) }} />
                            </Box>

                        </ListItem>
                        <Box display='flex' justifyContent='flex-end'>
                            <Button size='small' color='primary' onClick={() => popupState.close()}>{translate(`pos.common.close`)}</Button>
                        </Box>
                    </List>
                </Paper>
            </CustomPopover>
        </Box>
    )

}

const Item = ({ item, ...props }) => {
    const theme = useTheme()
    const [openEdit, setOpenEdit] = useState(false)
    const classes = useStyles()
    const translate = useTranslate()
    const popupState = usePopupState({ variant: 'popper', popupId: 'solution_schedule' });
    const popupStateMore = usePopupState({ variant: 'popper', popupId: 'more_schedule' });
    const dispatch = useDispatch();
    // const [openPreview, setOpenPreview] = useState(false)
    // const onPreview = () => {
    //     setOpenPreview(true);
    // }
    //
    // const onClosePreview = () => {
    //     setOpenPreview(false);
    // }


    const handleCopySchedule = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data];
        //let temp = { ...temps[props.index] }
        let temp = JSON.parse(JSON.stringify(temps[props.index]));
        temp.id && delete temp.id
        if (!temp.id && temp.fileOfSchedule && temp.fileOfSchedule.length > 0) {
            //console.log('handleCopySchedule',temp.fileOfSchedule);
            temp.fileOfSchedule.forEach(fos => fos.id && delete fos.id);
        }
        temps.push(temp)
        props.setData(temps)
        popupStateMore.close()
    }

    const handleDeleteSchedule = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...props.data];
        let removes = [...props.removes]
        let remove = { ...props.data[props.index] }
        removes.push({ type: 'schedule', id: remove.id })
        temps.splice(props.index, 1)
        props.setData(temps)
        props.setRemoves(removes)
        popupStateMore.close()
    }

    const onPreview = () => {
        props.onPreview(props.index);
        popupStateMore.close()
    }

    const onCloseDialog = () => {
        setOpenEdit(false)
    }
    const onOpenDialog = () => {
        setOpenEdit(true)
    }


    return (
        <Box p={3} style={{ border: '1px solid #c1e5fa', borderRadius: 4, backgroundColor: '#F9FBFD' }}>
            <Box display='flex'>
                <Box display='flex' flexGrow={1} alignItems='center'>
                    <Box display='flex' mr={4}>
                        <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.play`)}</Typography>
                        <Typography className={classes.titleDetailSchedule} style={{ textDecoration: 'underline' }}>{item.typeName}</Typography>
                    </Box>
                    {
                        item.typeName !== 'Always' && (
                            <Box display='flex' mr={4}>
                                <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.dateEdit`)}</Typography>
                                <Typography className={classes.titleDetailSchedule} style={{ textDecoration: 'underline', whiteSpace: 'pre' }}>
                                    {new Date(item.startDate).getDate() + ' ' + month[new Date(item.startDate).getMonth()].toLowerCase()}
                                    {item.typeName !== 'One time' ? `-${item.noEndDate ? translate(`resources.room.onGoing`) : new Date(item.stopDate).getDate() + ' ' + month[new Date(item.stopDate).getMonth()].toLowerCase()}` : ''}
                                </Typography>
                            </Box>
                        )
                    }

                    {
                        item.typeName === 'At intervals' && (
                            <Box display='flex' mr={4}>
                                <Typography className={classes.titleSchedule}>{translate(`pos.channels.intervalOf`)}</Typography>
                                <Typography className={classes.titleDetailSchedule} style={{ textDecoration: 'underline' }}>{item.interval + translate(`pos.channels.minutes`)}</Typography>
                            </Box>
                        )
                    }
                    {
                        item.typeName !== 'Always' && (
                            <Box display='flex' mr={4}>
                                <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.time`)}</Typography>
                                <Typography className={classes.titleDetailSchedule} style={{ textDecoration: 'underline' }}>{item.startTime + '-' + item.stopTime}</Typography>
                            </Box>
                        )
                    }

                    <Box display='flex' mr={4}>
                        <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.defaultImageTime`)}</Typography>
                        <Typography className={classes.titleDetailSchedule} style={{ textDecoration: 'underline' }}>{item.defaultShowTime + ' sec'}</Typography>
                    </Box>
                    <Box display='flex'>
                        <Typography className={classes.titleSchedule}>{translate(`pos.infochannel.sound`)}</Typography>
                        <Typography className={classes.titleDetailSchedule} style={{ textDecoration: 'underline' }}>
                            {item.sound === "" ? '' : item.sound.type}
                        </Typography>
                    </Box>
                </Box>

                <Box display='flex' alignItems='center'>
                    <Button
                        style={{ fontFamily: 'UniviaPro-Bold', fontSize: 9, lineHeight: '11px', letterSpacing: '0.36px', padding: 8 }}
                        variant='contained' color='primary' onClick={onOpenDialog}>
                        {translate(`pos.channels.editSchedule`)}
                    </Button>
                    <DialogEdit open={openEdit} data={item} arrayData={props.data} setData={props.setData} index={props.index} handleClose={onCloseDialog}></DialogEdit>
                    <IconButton
                        {...bindToggle(popupStateMore)}
                        style={{ backgroundColor: popupStateMore.isOpen ? theme.palette.primary.main : 'white', width: 28, height: 28, padding: 0, border: `solid 2px ${colors.lightBlue['100']}`, borderRadius: 10, marginLeft: theme.spacing(3) }}>
                        <img src={popupStateMore.isOpen ? icWhiteAdd : icBlueAdd} width={16} height={16}></img>
                    </IconButton>
                    <CustomPopover
                        popupState={popupStateMore}
                        zIndex={2}
                        placement='bottom'
                    >
                        <Paper style={{ padding: theme.spacing(1) }}>
                            <List >
                                <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={handleCopySchedule}>
                                    <img src={icCopy} width={15} height={15}></img>
                                    <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', cursor: 'pointer', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.copySchedule`)}</Typography>
                                </ListItem>
                                <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={onPreview}>
                                    <img src={icPlayChannel} width={15} height={15}></img>
                                    <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.playInfoChannel`)}</Typography>
                                </ListItem>
                                <ListItem button style={{ marginTop: theme.spacing(1) }} onClick={handleDeleteSchedule}>
                                    <img src={icDelete} width={15} height={15} ></img>
                                    <Typography className={classes.typography} style={{ fontSize: '13px', lineHeight: '16.3px', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.deleteSchedule`)}</Typography>
                                </ListItem>
                                <ListItem style={{ marginTop: theme.spacing(1) }}>
                                    <Box bgcolor='#f3f7fa' display='flex' width='100%' borderRadius='4px' px={1} py={0.5}>
                                        <Box flexGrow={1} display='flex' alignItems='center'>
                                            <Typography style={{ fontWeight: 'bold', letterSpacing: '0.36px', lineHeight: '11px', fontSize: 9, fontFamily: 'UniviaPro-Bold' }}>{translate(`pos.infochannel.disableInteraction`)}</Typography>
                                        </Box>
                                        <GreenSwitch size='small' checked={item.disableInteraction} onChange={props.onDisableInteractionChanged} />
                                    </Box>

                                </ListItem>
                                <Box display='flex' justifyContent='flex-end'>
                                    <Button size='small' color='primary' onClick={() => popupStateMore.close()}>{translate(`pos.common.close`)}</Button>
                                </Box>
                            </List>
                        </Paper>
                    </CustomPopover>
                </Box>
            </Box>
            {
                item.resolution ? <MediaContent item={item} {...props}></MediaContent> : <ChooseSolution popupState={popupState} {...props} />
            }
        </Box>
    )
}

export default Item